import React from 'react';
import { useLazyQuery } from '@apollo/client';

import {
  IMutationDeleteMediaArgs,
  IMediaUploadOutput,
  ISearchMediaOutput,
  IMutationUploadMediaArgs,
  ISearchMediaInput,
} from 'types/types';
import { mediaMutations, mediaQueries } from '.';
import { useMutationData } from 'api/apollo';

export const useDeleteMedia = () => {
  const [reloadAfterDeleted, setReloadAfterDeleted] = React.useState(false);
  const [deleteMedia, { loading, error }] = useMutationData<{ deleteMedia: { id: string } }, IMutationDeleteMediaArgs>({
    tData: 'deleteMedia',
    table: 'media',
    action: 'delete',
    mutation: mediaMutations.DELETE_MEDIA,
  });

  const mediaDelete = async (id: string) => {
    try {
      await deleteMedia({ variables: { input: { id } } });
      setReloadAfterDeleted(true);
    } catch {}
  };

  React.useEffect(() => {
    if (reloadAfterDeleted) {
      setReloadAfterDeleted(false);
    }
  }, [reloadAfterDeleted]);

  return { mediaDelete, error, loading, reloadAfterDeleted };
};

export const useUploadMedia = ({
  listInput,
  listData,
}: {
  listInput: ISearchMediaInput;
  listData: ISearchMediaOutput;
}) => {
  const [uploadMedia, { data, loading, error }] = useMutationData<
    { uploadMedia: IMediaUploadOutput },
    IMutationUploadMediaArgs
  >({
    tData: 'uploadMedia',
    table: 'media',
    action: 'add',
    mutation: mediaMutations.UPLOAD_MEDIA,
    /**
     * Update after uploaded file
     */
    updateCacheQuery: {
      type: 'searchMedia',
      query: mediaQueries.SEARCH,
      input: listInput,
      currentData: listData,
    },
  });

  const mediaUpload = (files: File[]) => {
    uploadMedia({ variables: { files } });
  };

  React.useEffect(() => {}, [data]);

  return { mediaUpload, data, error, loading };
};

export const useSearchMedia = () => {
  const [searchMedia, { loading, error, data }] = useLazyQuery<{ searchMedia: ISearchMediaOutput }>(
    mediaQueries.SEARCH,
    { fetchPolicy: 'network-only' },
  );

  return { data: data ? data.searchMedia : data, error, loading, searchMedia };
};
